import { EXPORT_FIELDS_PARAMS } from '../constants';

export const isAllSelected = (param) => param === EXPORT_FIELDS_PARAMS.all;
